export default {
  button: {
    form: { component: { name: 'd2p-button-input' } },
    disabled: true
  },
  number: {
    form: { component: { name: 'el-input-number', props: { } } },
    align: 'center'
  },
  switch: {
    form: { component: { name: 'el-switch', props: { } } },
    component: { name: 'el-switch', props: { } },
    align: 'center'
  },
  slider: {
    form: { component: { name: 'el-slider', props: { } } },
    align: 'center'
  },
  rate: {
    form: { component: { name: 'el-rate', props: { } } },
    align: 'center'
  },
  'color-picker': {
    form: { component: { name: 'el-color-picker', props: { } } },
    align: 'center'
  },
  transfer: {
    form: { component: { name: 'el-transfer', props: { } } },
    align: 'center'
  },
  autocomplete: {
    form: { component: { name: 'el-autocomplete', props: { } } }
  }
}
